/* eslint max-classes-per-file: 0 */

import Vue from 'vue'
import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


interface SelectedIdsMap {
  [key: number]: {
    currentIds: IData['id'][];
    indeterminateIds: IData['id'][];
  };
}

type IData = {
  id: string;
  code: string;
  selected: boolean;
  selected_by_child: boolean;
  selected_by_parent: boolean;
}

export const IS_LAST = true

export class TreeNode<T extends IData> {
  public $list?: readonly T[];

  public children: TreeNode<T>[] = [];

  public level = 0;

  public loading = false;

  public isIndeterminate = false;

  public isSelected = false;

  public isServerToggled = false;

  constructor(
    public data: T,
    public readonly root: RootTreeNode<T>,
    public readonly parent: TreeNode<T>,
    public isLast = false,
    public isActive = false,
  ) {
    this.data = data

    this.isServerToggled = 'selected' in data

    if (parent) this.level = parent.level + 1
    if (root) this.update()
  }

  public getIsIndeterminate(): boolean {
    if (this.isServerToggled) return this.data.selected_by_child

    if (this.isSelected) return false
    if (this.isLast) return false

    const selectedIdsMap = this.root.selectedIdsMap || {}
    if (this.level in selectedIdsMap) {
      const { indeterminateIds } = selectedIdsMap[this.level]
      return indeterminateIds.includes(this.data.id)
    }

    // return this.children.some((_) => _.isSelected || _.isIndeterminate)
    return false
  }

  public getIsSelected(): boolean {
    if (this.isServerToggled) return this.data.selected

    const selectedIdsMap = this.root.selectedIdsMap || {}
    if (this.level in selectedIdsMap) {
      const { currentIds } = selectedIdsMap[this.level]
      return currentIds.includes(this.data.id)
    }

    return false
  }

  public update() {
    this.isIndeterminate = this.getIsIndeterminate()
    this.isSelected = this.getIsSelected()

    if (this.isServerToggled) return

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    void this.children?.forEach((node) => node.update())
  }

  public get isSelectedParent(): boolean {
    if (this.isServerToggled) return this.data.selected_by_parent

    if (!this.parent) return false
    return this.parent.isSelected || this.parent.isSelectedParent
  }

  public setChildren(list?: T[], isLast = false, isActive = false) {
    this.$list = Object.freeze(list)

    if (!list?.length) {
      // this.isLast = IS_LAST
      this.children = []
    } else {
      const oldChildren = this.children.slice()

      const children = list.map((data) => {
        const index = oldChildren
          .findIndex((node) => node.data.id === data.id)

        if (index === -1) {
          return new TreeNode(data, this.root, this, isLast, isActive)
        }

        const [node] = oldChildren.splice(index, 1)
        node.data = data
        node.update()
        return node
      })

      this.children = children
    }
  }

  public toggleSelected(isSelected = !this.isSelected, parent = true): boolean {
    if (this.isServerToggled) {
      this.isSelected = isSelected
      this.data.selected = isSelected
      return isSelected
    }

    if (this.children) {
      void this.children.forEach((_) => _.toggleSelected(false, false))
    }

    if (!parent || !this.parent) {
      this.isSelected = isSelected
      return isSelected
    }

    if (this.isSelectedParent) {
      this.parent.toggleSelectedParent(false)
      this.isSelected = false
    } else {
      this.isSelected = isSelected
      if (isSelected) this.parent.toggleSelectedParent(isSelected)
    }

    return isSelected
  }

  protected toggleSelectedParent(isSelected: boolean) {
    if (!this.children) {
      this.isSelected = isSelected
      return
    }

    if (!isSelected) {
      // eslint-disable-next-line no-param-reassign
      this.children.forEach((_) => { _.isSelected = true })
      if (!this.isSelected) {
        void this.parent?.toggleSelectedParent(false)
      // хелпер что бы отключить у родителя isSelected
      } else if (this.parent) {
        this.parent.isSelected = false
      }

      this.isSelected = false
    }

    if (isSelected) {
      const isAllSelected = this.children.every((_) => _.isSelected)
      if (isAllSelected) this.toggleSelected(true, true)
      // TODO
    }
  }
}

export class RootTreeNode<T extends IData> extends TreeNode<T> {
  public selectedIdsMap!: SelectedIdsMap;

  public root = this;

  public toggleSelected(isSelected = !this.isSelected): boolean {
    super.toggleSelected(isSelected)

    if (this.isSelected) {
      // eslint-disable-next-line no-param-reassign
      void this.children.forEach((_) => { _.isSelected = true })
    }

    return this.isSelected
  }

  public setChildren(list?: T[], isLast = false, isActive = false) {
    super.setChildren(list, isLast, isActive)
    this.update()
  }

  public getIsSelected(): boolean {
    return this.children.every((node) => node.isSelected)
  }

  public setSelectedIdsMap(data: SelectedIdsMap) {
    this.selectedIdsMap = data
    this.update()
  }
}


export const createBAteTreeParticipantsImportModal = (
  parent: Vue,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "BAteTreeParticipantsImportModal" */
    './BAteTreeParticipantsImportModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
